import { Component, Input, OnInit } from '@angular/core';
import { PartnerServicesService } from 'src/app/services/partner-service/partner-services.service';
import { UiService } from 'src/app/services/ui/ui.service';
import { HelperFunctions } from 'src/app/services/helper-functions';
import { TranslateService } from '@ngx-translate/core';
import { UserManagerService } from 'src/app/services/user-manager/user-manager.service';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { NewProductComponent } from '../new-product/new-product.component';
import { InputSearchFilter, customSlelect, CheckboxFilter } from 'src/app/interface/interfaces';
@Component({
  selector: 'app-prod-table',
  templateUrl: './p-table.component.html',
  styleUrls: ['./p-table.component.scss']
})
export class PTableComponent implements OnInit {
  @Input() id: any;
  @Input() navs: any;
  searchdata: any = {
    page: 0,
    size: 20,
    name: '',
    product_type: '',
  };
  loadingMatches = false;

  inProgress = false;
  currentPage = 1;
  permissions = {
    canEdit: false,
    canAdd: false
  };
  checkboxes: Array<CheckboxFilter> = [ {label: 'actif', action: 'status', value: false}];

  createdSuccessfully: boolean;
  inputSearches: Array<InputSearchFilter> = [
    { placeholder : '', label: 'name', action: 'name', value: ''},
    // { placeholder : '', label: 'username', action: 'uname', value: ''}
  ];
selectFilters: Array<customSlelect>;
  constructor(private uiService: UiService,
              private helperFunction: HelperFunctions,
              public partnerService: PartnerServicesService,
              private translate: TranslateService,
              private userService: UserManagerService,
              private router: Router,
              private route: ActivatedRoute,
              public dialog: MatDialog) {

   }

  ngOnInit() {
    this.uiService.active = 'products';
    this.permissions.canEdit = this.userService.hasPrevilleges('SPORTS_P_B_EDIT_PRODUCTS');
    this.permissions.canAdd = this.userService.hasPrevilleges('SPORTS_P_B_ADD_PRODUCTS');
    this.partnerService.loadProductTypes().then(res => {
      // console.log(this.partnerService.partners);
      this.selectFilters = [
        {
          placeholder: 'select_product_type',
          label: 'product_type',
          data: this.partnerService.productTypes,
          isRefreshing: false,
          type: 'product_type',
          emptyMessage: this.translate.instant('no_product_type_available'),
          selectKey: 'product_type',
          priority: true,
          optionKey: 'name',
          itemKey: 'id',
          loading: false
        }
      ];
    });
    this.searchdata.pid = this.id;
    // console.log(this.searchdata)
    this.loadProducts();

  }
  searchData(searchdata) {
    const perpage = this.searchdata.size;
    // searchdata.status = searchdata.status ?.toString();
    this.searchdata = searchdata;
    this.searchdata.page = 0;
    this.currentPage = 1;
    this.searchdata.size = perpage;
    this.loadingMatches = true;
    this.partnerService.loadProducts(this.searchdata).then(_ => {
        this.loadingMatches = false;
      });
  }
  openDialog(item?): void {
    const dialogRef = this.dialog.open(NewProductComponent, {
      maxWidth: '40%',
      disableClose: true,
      panelClass: "scrollable",
      data: { pid: this.id,
              created: this.createdSuccessfully,
              product: item,
              }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.searchdata.page = 0;
        this.currentPage = 1;
        this.searchdata.size = 20;
        this.loadProducts();
      }
    });
  }


  ngAfterContentInit(): void {
    this.searchdata.filter = '';
    if (!this.partnerService.partners.length) {
      this.loadingMatches = true;
      this.partnerService.loadPartners(this.searchdata).then(response => {
      }).catch(error => {
      }).finally(() => {
        this.loadingMatches = false;
      });
    }
  }

  getNewPageData(page) {
    this.currentPage = page;
    this.searchdata.page = page === 0 ? page : page - 1;
    this.partnerService.loadProducts(this.searchdata);
  }
  changePerPage(ev: KeyboardEvent, perpageInput: HTMLInputElement) {
    if (ev.key.toLowerCase() === 'enter') {
      this.inProgress = true;
      const  res = this.partnerService.changePerPage(ev, perpageInput.value, this.searchdata.size);
      // console.log(res);
      this.searchdata.size = res[1];
      const searchdata = Object.assign(this.searchdata);
      res[0] == 'load-more' ? searchdata.page++ : '';
      this.partnerService.loadProducts(searchdata, res[0]).then(_ => {
        }).finally(() =>{
          res[0] == 'load-more' ? searchdata.page-- : '';
        });
      this.inProgress = false;
      this.searchdata.size = Number (perpageInput.value);
    }
  }
  loadProducts() {
    this.inProgress = true;
    this.partnerService.loadProducts(this.searchdata).then(_ => {
    }).finally(() => {
      this.inProgress = false;
    });
    // console.log(this.partnerService.products)
  }

  editProvider(row, text, message, key) {
    this.helperFunction.presentAlert('warning', this.translate.instant('are_you_sure'), '',
      text).then((result) => {
      if (result.value) {
        const params = {
          id: row.id
        };
        params[key] = !row[key];

        this.helperFunction.presentAlertLoader();

        this.partnerService.editProvider(row.id, params).then(data => {
          Swal.close();
          if (data && data.hasOwnProperty('erc') && data.erc === '1') {
            row[key] = !row[key];
            this.helperFunction.presentAlert('success', this.translate.instant('success'), '',
              message, null);
          } else {
            this.helperFunction.presentAlert('error', this.translate.instant('failed'), '',
              data.msg ? data.msg : this.translate.instant('something_went_wrong') , null);
          }
        }).catch(err => {
          Swal.close();
          // console.log(err);
          this.helperFunction.presentAlert('error', this.translate.instant('failed'), '',
              this.translate.instant('server_error') , null);
        }).finally(() => {
        });
      }
    });
  }
  disableSlide(row, ev) {
    ev.preventDefault();
    // console.log(row)
    const warning = row.status ? 'do_you_really_want_to_disable_product' : 'do_you_really_want_to_enable_product';
    // tslint:disable-next-line: max-line-length
    this.helperFunction.presentAlert('warning', this.translate.instant('are_you_sure') + '?', '', this.translate.instant(warning)).then(result => {
      if (result.value) {
        this.helperFunction.presentAlertLoader();
        const params = {
         id : row.id,
       };
        this.partnerService.changeProductStatus(params).then(data => {
          Swal.close();
          if (data && data.hasOwnProperty('erc') && data.erc === '1') {
            // tslint:disable-next-line: max-line-length
            const message = row.status ? this.translate.instant('product_disabled_successfully') : this.translate.instant('product_enabled_successfully');
            row.status = !row.status;
            this.helperFunction.presentAlert('success', this.translate.instant('success'), '',
            message, null);
          } else {
            this.helperFunction.presentAlert('error', this.translate.instant('failed'), '',
                data.msg ? data.msg : this.translate.instant('something_went_wrong') , null);
          }
        }).catch(err => {
          Swal.close();
          this.helperFunction.presentAlert('error', this.translate.instant('failed'), this.translate.instant('server_error') , null);
        }).finally(() => {
        });
      }
    });
  }
  goToDetailsPage(row) {
    this.partnerService.activepartner = row;
    this.router.navigate([row.id], {relativeTo: this.route});
  }

  partnerDetail(data, tabIndex) {
    data.tabIndex = tabIndex;
    this.partnerService.activePartnerDetails = data;
    // console.log(data);
    this.router.navigate(['home/products', data.id]);
  }
}
